// Códigos de retención de Sage Despachos: identificadores internos de Sage
//
// Se guardan en Profile.default_settings['sage_despachos']['retentions']
//
// Espejo frontend de backend_adp/backend/ddd/company/domain/SageDespachosRetentionCodes.py:
// si se cambia una, hay que cambiar la otra.

export const SAGE_DESPACHOS_SETTINGS_KEY = 'sage_despachos'

export const SAGE_DESPACHOS_RETENTIONS_KEY = 'retentions'

interface SageDespachosRetentionRow {
  name: string
  value: string
  default: number | null
}

// Única fuente de verdad: filas + default. Orden = orden de las filas en la tabla.
// `value` es la clave estable de cada fila: sirve de :key en la tabla y de clave en
// default_settings.
export const SAGE_DESPACHOS_RETENTION_ROWS: SageDespachosRetentionRow[] = [
  { name: 'Alquiler', value: 'retention_rental_account', default: 19 },
  { name: 'Engorde porcino', value: 'retention_livestock_account', default: null },
  { name: 'Agricultura y ganadería', value: 'retention_agriculture_account', default: 2 },
  { name: 'Profesional', value: 'retention_professional_account', default: 15 },
  { name: 'Profesional Inicio Act.', value: 'retention_professional_start_act_account', default: 7 },
  { name: 'Transporte', value: 'retention_transport_account', default: null },
]

export const DEFAULT_SAGE_DESPACHOS_RETENTION_CODES: Record<string, number | null> =
  SAGE_DESPACHOS_RETENTION_ROWS.reduce((acc, row) => {
    acc[row.value] = row.default
    return acc
  }, {} as Record<string, number | null>)

// Un código válido es un entero >= 0, o vacío ("sin código")
export function isValidRetentionCode(value: unknown): boolean {
  if (value === null || value === undefined || value === '') {
    return true
  }
  return /^\d+$/.test(String(value).trim()) && String(value).trim() !== ''
}

// Vacío o no numérico -> null; el resto -> entero. El 0 se conserva: es un código
// de Sage válido y distinto de "sin código".
export function normalizeRetentionCode(value: unknown): number | null {
  if (value === null || value === undefined || value === '') {
    return null
  }
  const parsed = parseInt(String(value), 10)
  return isNaN(parsed) ? null : parsed
}

// Resuelve las claves guardadas en default_settings contra el default
export function resolveRetentionCodes(defaultSettings: any): Record<string, number | null> {
  const sageBlock = (defaultSettings && defaultSettings[SAGE_DESPACHOS_SETTINGS_KEY]) || {}
  const storedRaw = sageBlock[SAGE_DESPACHOS_RETENTIONS_KEY]
  const stored = (storedRaw && typeof storedRaw === 'object' && !Array.isArray(storedRaw))
    ? storedRaw
    : {}

  const result: Record<string, number | null> = {}
  for (const row of SAGE_DESPACHOS_RETENTION_ROWS) {
    result[row.value] = row.value in stored
      ? normalizeRetentionCode(stored[row.value])
      : row.default
  }
  return result
}


// Entrada `retentions` del PATCH a update_profile_default_settings
export function buildRetentionCodesSetting(keys: Record<string, unknown>): object {
  return {
    is_enabled: true,
    value: resolveRetentionCodes({
      [SAGE_DESPACHOS_SETTINGS_KEY]: { [SAGE_DESPACHOS_RETENTIONS_KEY]: keys }
    })
  }
}
